//  Page load event
document.addEventListener('DOMContentLoaded', function () {
  const revealElements = document.querySelectorAll('.reveal-on-scroll');

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('revealed');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1 
  });

  revealElements.forEach(el => observer.observe(el));
});


// 
document.addEventListener('DOMContentLoaded', function () {
  const slides = document.querySelectorAll('[id^="Slide-template"]');
  const thumbnails = document.querySelectorAll('[id^="Slide-Thumbnails"]');

  // 1. Thumbnail click -> scroll main image
  thumbnails.forEach((thumbnail, index) => {
    thumbnail.addEventListener('click', function () {
      slides[index]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    });
  });

  // 2. Main image scroll -> activate corresponding thumbnail
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const activeMediaId = entry.target.getAttribute('data-media-id');

        thumbnails.forEach((thumb) => {
          const thumbTarget = thumb.getAttribute('data-target');

          if (thumbTarget === activeMediaId) {
            thumb.classList.add('is-active');
            thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          } else {
            thumb.classList.remove('is-active');
          }
        });
      }
    });
  }, {
    root: document.querySelector('#Slider-Gallery-template-18748755767893__main'),
    threshold: 0.6
  });

  slides.forEach((slide) => {
    if (slide.getAttribute('data-media-id')) {
      observer.observe(slide);
    }
  });
});




